<footer class="footer">
  <div class="d-flex flex-fill" *ngIf="isThemeActiveReceitaDigital()">
    <a class="mr-3 helpContainer" target="_blank" href="https://ajuda.receitadigital.com"><i class="fa fa-comments mr-1"></i>Fale Conosco.</a>
  </div>
</footer>
